// @flow
import ListModel from "../list/ListModel";

import type { ModularUIResponse } from "../../modularui";
import type { IFilter } from "../types";

/**
 * Case search model
 */
export default class CaseSearchModel extends ListModel {
  /**
   */
  get type(): string {
    return "CaseSearch";
  }

  /**
   */
  static get modelName(): string {
    return "CaseSearchModel";
  }

  /**
   */
  static isApplicableModel(data: ModularUIResponse): boolean {
    return (
      data.contributions.resourcetype &&
      data.contributions.resourcetype === "CaseSearch"
    );
  }

  /**
   * Retrieve quick search filters
   */
  getQuickSearchFilters(): Array<IFilter> {
    return this.filterCollection
      ? this.filterCollection.filter((filter) => filter.isQuickSearch())
      : [];
  }

  /**
   */
  hasQuickSearchFilters(): boolean {
    return this.getQuickSearchFilters().length > 0;
  }
}
